import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive({ selector: '[isAllowed]' })
export class IsAllowedDirective implements OnDestroy, OnInit {
	@Input() isAllowed: string[] | string = [];
	private hasRendereView = false;
	private subscriptions: Subscription[] = [];

	constructor(private templateRef: TemplateRef<any>, private vcr: ViewContainerRef) {}

	ngOnInit() {
		if (!this.hasRendereView) {
			this.vcr.createEmbeddedView(this.templateRef);
			this.hasRendereView = true;
		} else {
			this.vcr.clear();
			this.hasRendereView = false;
		}
		/*
		this.subscriptions.push(
			this.permissionStore.shouldRevalidate$.subscribe(r => {
				if (typeof this.isAllowed == 'string') {
					this.isAllowed = [this.isAllowed];
				}
				var hasPermission = this.permissionStore.canUse(this.isAllowed[0]);
				if (hasPermission && !this.hasRendereView) {
					this.vcr.createEmbeddedView(this.templateRef);
					this.hasRendereView = true;
				} else {
					this.vcr.clear();
					this.hasRendereView = false;
				}
			}),
		);*/
	}

	ngOnDestroy() {
		this.subscriptions.forEach(sub => {
			sub.unsubscribe();
		});
	}
}
